import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import userAPI from "../api/userAPI";
import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import { useSelector } from "react-redux";
import { isPartnerClalit, selectPartner } from "../store/partnerStore";
import { getExternalSystem } from "../utils/partner";
import swalDialog from "../helpers/swalErrorPopup";
import { isV2Enabled, V2_SCREEN_KEYS } from "../v2/registry";
import PhoneValidationV2 from "../v2/screens/phoneValidation/PhoneValidation";

function UserPhoneValidation() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [phone, setPhone] = useState("");
  const [lastName, setLastName] = useState(null);
  const [username, setUsername] = useState("");
  const [continueBtn, setContinueBtn] = useState(true);
  const [smsPayload, setSMSPayload] = useState(null);
  const [displayError, setDisplayError] = useState(false);
  const isClalit = useSelector(isPartnerClalit);
  const partner = useSelector(selectPartner);

  useEffect(() => {
    if (location?.state) {
      setSMSPayload(location.state);
      setUsername(location.state?.FirstName);
    }
  }, [location.state]);

  const onClickContinue = async () => {
    const payload = { ...smsPayload, Phone: phone, ExternalSystem: getExternalSystem() };
    if (isClalit && lastName) {
      payload.LastName = lastName.trim();
    }
    const result = await userAPI.sendSmsCode(payload);
    if (result.data.IsPhoneValid) {
      navigate("/otp-validation", { state: payload });
    } else {
      setDisplayError(true);
      setPhone("");
      setContinueBtn(true);
    }
  };

  // V2 submit — same payload as onClickContinue above, plus the error feedback
  // the legacy path lacks (V2-only fix): a failed SendSmsCode reaches swalDialog
  // instead of an unhandled rejection. Resolves false when the server rejects
  // the phone, so the V2 input clears itself like the legacy screen did.
  const onSubmitV2 = async (v2Phone, v2LastName) => {
    const payload = { ...smsPayload, Phone: v2Phone, ExternalSystem: getExternalSystem() };
    if (isClalit && v2LastName) {
      payload.LastName = v2LastName.trim();
    }
    try {
      const result = await userAPI.sendSmsCode(payload);
      if (result.data.IsPhoneValid) {
        navigate("/otp-validation", { state: payload });
        return true;
      }
      setDisplayError(true);
      return false;
    } catch (err) {
      swalDialog(err);
      return false;
    }
  };

  // V2 phone-validation page. onSubmitV2 above owns SendSmsCode + navigation.
  if (isV2Enabled(V2_SCREEN_KEYS.USER_PHONE_VALIDATION, partner))
    return (
      <PhoneValidationV2
        fullName={username}
        needLastName={isClalit && !location.state?.LastName}
        displayError={displayError}
        onSubmit={onSubmitV2}
      />
    );

  return (
    <div className="user-phone-validation-container">
      <div className="user-phone-validation-wrapper">
        <div className="user-instruction">
          <span className="username">
            {t("HEY")} {username},
          </span>
          <span className="instruction">{t("PHONE_VALIDATION.TWO_FACTOR_AUTH")}</span>
        </div>

        {isClalit && !location.state?.LastName && (
          <div className="user-inputs">
            <input
              type="text"
              id="lastName"
              name="lastName"
              placeholder={t("PHONE_VALIDATION.LAST_NAME_PLACEHOLDER")}
              className="input"
              style={{ fontSize: "16px" }}
              value={lastName}
              onChange={(e) => {
                setLastName(e.target.value);
                setContinueBtn(e.target.value.trim().length === 0 || phone.length < 10);
              }}
            />
          </div>
        )}

        <div className="user-inputs">
          <input
            type="tel"
            id="phone"
            name="phone"
            placeholder={t("PHONE_VALIDATION.PHONE_PLACEHOLDER")}
            className="input"
            style={{ fontSize: "16px" }}
            value={phone}
            onChange={(e) => {
              setPhone(e.target.value);
              setContinueBtn(e.target.value?.length < 10 || (!location.state?.LastName && (!lastName || lastName.trim().length === 0)));
            }}
          />
          <button className="continue-button" disabled={continueBtn} onClick={() => onClickContinue()}>
            {t("PHONE_VALIDATION.CONTINUE")}
          </button>
          {/* {resendCode && <span className="voice-code">שלחו לי קוד קולי</span>} */}
        </div>

        {displayError && (
          <div className="error-message-container">
            <p className="error-message">{t("PHONE_VALIDATION.PHONE_ERROR_HEADER")}</p>
            <p className="error-message">
              {t("PHONE_VALIDATION.PHONE_ERROR_MESSAGE")}
              <a href="tel:033730300">03-3730300</a>
            </p>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}

export default UserPhoneValidation;
